module.exports = __webpack_public_path__ + "img/pro-photo10.f795a20a.png";